import { getLoginRedirectNotifier } from "@/infrastructure/di/services";
import { ROUTES } from "@/app/routes";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Subscribes to login-redirect notifications dispatched by AuthContext
 * after session expiration. Use in layout components instead of raw
 * window.addEventListener('auth:redirect-to-login', …).
 */
export function useLoginRedirectHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    return getLoginRedirectNotifier().subscribe(() => {
      navigate(ROUTES.AUTH.LOGIN, { replace: true });
    });
  }, [navigate]);
}
